export * from './supervisor-new.component';
